import { HORIZON, drawWater, ell, hash01, hills, skyGradient } from '../common';
import type { DrawCtx, SceneArt } from './types';

function pine(ctx: CanvasRenderingContext2D, x: number, base: number, h: number): void {
  ctx.fillStyle = '#4F7C80';
  ctx.beginPath();
  ctx.moveTo(x, base - h);
  ctx.lineTo(x + h * 0.32, base);
  ctx.lineTo(x - h * 0.32, base);
  ctx.closePath();
  ctx.fill();
  ctx.fillStyle = '#FFFFFF';
  ctx.beginPath();
  ctx.moveTo(x, base - h);
  ctx.lineTo(x + h * 0.12, base - h * 0.62);
  ctx.lineTo(x - h * 0.12, base - h * 0.62);
  ctx.closePath();
  ctx.fill();
}

export const ice: SceneArt = {
  id: 'ice',
  rope: '#D7263D',
  ropeBack: '#9E1B2C',
  handle: '#D7263D',
  ring: 'rgba(40,90,140,0.7)',
  ground: {
    waterTop: '#D3ECF5', waterBottom: '#9CCBDD', shimmer: 'rgba(255,255,255,0.55)',
    padTop: '#F4FBFE', padEdge: '#A9D2E3', padVein: 'rgba(110,165,195,0.55)',
    post: '#8A5A3B', postDark: '#6C432A', postCap: '#B98457', ripple: 'rgba(120,170,200,0.6)', snow: true,
  },
  drawBack(d: DrawCtx) {
    const { ctx, v, t } = d;
    skyGradient(ctx, v, [[0, '#A9D8EE'], [0.7, '#D6EEF8'], [1, '#F1F9FC']]);
    ell(ctx, 540, 250, 30, 30);
    ctx.fillStyle = 'rgba(255,255,255,0.9)';
    ctx.fill();
    hills(ctx, v.L, v.R, 350, 36, 0.011, 0.4, '#E3F0F6');
    for (let i = 0; i < 14; i++) {
      const x = v.L + (i + 0.3) * ((v.R - v.L) / 14);
      pine(ctx, x, 356 - hash01(i + 9) * 8, 30 + hash01(i) * 26);
    }
    hills(ctx, v.L, v.R, 362, 14, 0.024, 2.4, '#CFE4EE');
    drawWater(ctx, v, d.reduced ? 0 : t * 0.2, this.ground, 0.6);
    // cracks in the ice
    ctx.strokeStyle = 'rgba(110,165,195,0.5)';
    ctx.lineWidth = 1.5;
    for (let i = 0; i < 9; i++) {
      let x = v.L + hash01(i + 50) * (v.R - v.L);
      let y = HORIZON + 30 + hash01(i + 70) * 120;
      ctx.beginPath();
      ctx.moveTo(x, y);
      for (let k = 0; k < 4; k++) {
        x += 14 + hash01(i * 7 + k) * 22;
        y += (hash01(i * 3 + k) - 0.5) * 16;
        ctx.lineTo(x, y);
      }
      ctx.stroke();
    }
  },
  drawFront(d: DrawCtx) {
    const { ctx, v, t } = d;
    const W = v.R - v.L;
    const H = v.B - v.T;
    const n = d.reduced ? 30 : 80;
    ctx.fillStyle = 'rgba(255,255,255,0.9)';
    for (let i = 0; i < n; i++) {
      const sp = 0.5 + hash01(i + 3);
      const x = v.L + ((((hash01(i) * W + Math.sin(t * 0.8 + i) * 20 + t * 14) % W) + W) % W);
      const y = v.T + ((hash01(i + 7) * H + t * 38 * sp) % H);
      ell(ctx, x, y, 1.4 + sp, 1.4 + sp);
      ctx.fill();
    }
  },
};
